import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto md:mx-0" }
const _hoisted_3 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 md:pr-8 mx-auto" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import DepositFilterDialog from "@/components/dialogs/DepositFilterDialog.vue";
import { formatNumber, translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'DepositV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const columns = ref([
  {
    label: translate("messages.depositTransaction.user"),
    field: "username",
    format: (data: any) =>
      data.raw_data?.referenceRequest?.requestBody?.username
        ? data.raw_data?.referenceRequest?.requestBody?.username
        : data.user_id,
  },
  {
    label: translate("messages.depositTransaction.channel"),
    field: "channel",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) =>
      data.channel
        ? data.channel
        : data.raw_data?.referenceRequest?.requestBody?.type,
  },
  {
    label: translate("messages.depositTransaction.amount"),
    field: "amount",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.amount, 100),
    class: (data: any) =>
      Number(data.amount) < 0
        ? "text-red-500"
        : "text-green-500",
  },
  {
    label: translate("messages.depositTransaction.refCode"),
    field: "ref_code",
    align: "center",
    sort: true,
    isSorted: false,
  },
  {
    label: translate("messages.depositTransaction.date"),
    field: "updated_at",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.updated_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.depositTransaction.approvedBy"),
    field: "admin",
    align: "center",
    format: (data: any) =>
      data.raw_data?.referenceRequest?.requestBody?.admin
        ? data.raw_data?.referenceRequest?.requestBody?.admin
        : data.raw_data?.referenceRequest?.requestBody?.user &&
          data.raw_data?.referenceRequest?.requestBody?.user?.username
        ? data.raw_data?.referenceRequest?.requestBody?.user?.username
        : null,
  },
  {
    label: translate("messages.depositTransaction.approveMessage"),
    field: "admin",
    align: "center",
    format: (data: any) =>
      data.raw_data?.referenceRequest?.requestBody?.body?.approve_remarks
        ? data.raw_data.referenceRequest.requestBody.body.approve_remarks
        : '-',
  },
]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  sort: [["seq_num", "DESC"]],
});
const filterForm = ref({
  username: null,
  channel: null,
  moduleCode: null,
  from: null,
  to: null,
});

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};
const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;

  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date") attName = "seq_num";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};
const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;
  const { username, channel, moduleCode, from, to } = filterForm.value;
  // let sort = [["created_at", "DESC"]]
  // let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page - 1,
    pageSize: rowsPerPage,
    fillter: {
      username: username || null,
      channel: channel !== "All" ? channel : null,
      moduleCode: moduleCode || null,
    },
    startDate: dayjs(from) || null,
    endDate: dayjs(to) || null,
    sortBy: sort,
  };
  if (!from) delete payload.startDate;
  if (!to) delete payload.endDate;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/cms/deposit-record-all/pagination`;
  const { result: data } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  // if(!data || data.length == 0){
  //   if(page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data;

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `deposit?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.depositTransaction.depositTransactions')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DateSelector, { onSearch: onSearch }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (filterModal())),
              class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-white mr-2",
                icon: ['far', 'filter'],
                transform: ""
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.depositTransaction.advanceFilter")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(DataTable, {
              columns: columns.value,
              data: dataRows.value,
              onSort: doSort,
              isLoaded: isLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(DepositFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"])
  ], 64))
}
}

})